module.exports = __webpack_public_path__ + "img/ai.0b357a07.png";